import { createContext, useContext } from 'react';

var DataGridContext = /*#__PURE__*/createContext(null);
var useDataGridContext = function useDataGridContext() {
  var context = useContext(DataGridContext);
  if (!context) {
    throw new Error('useDataGridContext must be used within a DataGridContextProvider');
  }
  return context;
};

export { DataGridContext, useDataGridContext };
